<div>
  <kl-fpo-lists [fpoList]="dialogData?.data?.fpoList" (closeFpoDialog)="ok()"></kl-fpo-lists>
</div>
